// The files in the platform agent's message box (D6, docs/platform-agent/contracts.md §8). The label, placeholder
// and hint stay in PlatformAgentConversation's `composer`.
export default {
  drop: 'Dateien hier ablegen: PDF, Fotos, Excel, CSV oder Word',
  waiting: 'Gesendet wird, sobald die Dateien hochgeladen sind.',
  // A PDF's pages on its tile (B37): "PDF · 1,2 MB · 4 Seiten".
  pages_one: '{{count}} Seite',
  pages_other: '{{count}} Seiten',
  problems: {
    type: 'Diese Art von Datei kann nicht gesendet werden. Schick ein PDF, ein Foto (JPG, PNG oder HEIC) oder eine Excel-, CSV- oder Word-Datei.',
    size: 'Über 20 MB. Eine Datei darf höchstens 20 MB groß sein.',
    empty: 'Diese Datei ist leer.',
    count: 'Bis zu 10 Dateien pro Nachricht.',
    upload: 'Der Upload wurde abgebrochen. Versuch es noch mal.',
  },
};
